var _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF"
    },
    d: "M19.32 8.18H10v3.87h5.36c-.5 2.45-2.6 3.86-5.36 3.86-3.27 0-5.9-2.62-5.9-5.9 0-3.26 2.63-5.9 5.9-5.9 1.4 0 2.68.5 3.68 1.3l2.9-2.9C14.83.96 12.56 0 10 0 4.45 0 0 4.45 0 10s4.45 10 10 10c5 0 9.55-3.64 9.55-10 0-.6-.1-1.23-.23-1.82z",
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBC05"
    },
    fill: "#FBBC05",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "M-.9 15.9V4.1L6.8 10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA4335"
    },
    fill: "#EA4335",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "M-.9 4.1L6.8 10 10 7.23l10.9-1.78V-.9H-.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34A853"
    },
    fill: "#34A853",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "M-.9 15.9L12.72 5.46l3.6.46L20.9-.9v21.8H-.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4285F4"
    },
    fill: "#4285F4",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "M20.9 20.9L6.83 10 5 8.64 20.9 4.1"
  })));
};
export default SvgGoogle;